import {
  createFrontendPlugin,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import PeopleIcon from '@material-ui/icons/People';

export const usersRouteRef = createRouteRef();

const usersPage = PageBlueprint.make({
  params: {
    routeRef: usersRouteRef,
    path: '/users',
    title: 'Users',
    icon: <PeopleIcon />,
    loader: () => import('./UsersPage').then(m => <m.UsersPage />),
  },
});

export const usersPlugin = createFrontendPlugin({
  pluginId: 'users',
  routes: {
    root: usersRouteRef,
  },
  extensions: [usersPage],
});
